import Cookies from "js-cookie";
import * as adminApi from "../../../services/admin";
import {
  ADMIN_LOGIN_FAILURE,
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGOUT_FAILURE,
  ADMIN_LOGOUT_REQUEST,
  ADMIN_LOGOUT_SUCCESS,
  ADMIN_ME_FAILURE,
  ADMIN_ME_REQUEST,
  ADMIN_ME_SUCCESS,
} from "./admin.actionType";

export const requestlogin = () => {
  return {
    type: ADMIN_LOGIN_REQUEST,
  };
};

export const loginSuccess = (data) => {
  return {
    type: ADMIN_LOGIN_SUCCESS,
    data,
  };
};

export const loginFailure = (message) => {
  return {
    type: ADMIN_LOGIN_FAILURE,
    message,
  };
};

export const loginAdmin = (data) => {
  return (dispatch) => {
    dispatch(requestlogin());
    return adminApi
      .adminLogin(data)
      .then((resp) => {
        let user = resp.data.user;
        dispatch(loginSuccess(user));
        let token = resp.data.jwt;
        Cookies.set("token", token, { expires: 1 });
        return;
      })
      .catch((err) => {
        const errorMessage = err.response
          ? err.response.data.message[0].messages[0].message
          : "Something went wrong";
        dispatch(loginFailure(errorMessage));
        throw err
      });
  };
};

export const requestMe = () => {
  return {
    type: ADMIN_ME_REQUEST,
  };
};

export const meSuccess = (data) => {
  return {
    type: ADMIN_ME_SUCCESS,
    data,
  };
};

export const meFailure = () => {
  return {
    type: ADMIN_ME_FAILURE,
  };
};

export const Me = () => {
  return (dispatch) => {
    dispatch(requestMe());
    return adminApi
      .me()
      .then((resp) => {
        const data = resp.data;
        dispatch(meSuccess(data));
      })
      .catch((err) => {
        dispatch(meFailure());
        throw err;
      });
  };
};

export const requestLogout = () => {
  return {
    type: ADMIN_LOGOUT_REQUEST,
  };
};

export const logoutSuccess = () => {
  return {
    type: ADMIN_LOGOUT_SUCCESS,
  };
};

export const logoutFailure = () => {
  return {
    type: ADMIN_LOGOUT_FAILURE,
  };
};

export const logoutAdmin = () => {
  return (dispatch) => {
    dispatch(requestLogout());
    try {
      Cookies.remove("token");
      dispatch(logoutSuccess());
    } catch (err) {
      dispatch(logoutFailure());
      throw err;
    }
  };
};
